import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "results-facets",
  class ResultsFacets extends WYATTElement {
    constructor() {
      super();

      this.groupTemplate = this.querySelector('[data-template="group"]');
      this.valueFacetTemplate = this.querySelector(
        '[data-template="value-facet"]',
      );
      this.rangeFacetTemplate = this.querySelector(
        '[data-template="range-facet"]',
      );
      this.readMoreButtonTemplate = this.querySelector(
        '[data-template="read-more-button"]',
      );
      this.numbersTemplate = this.querySelector('[data-template="numbers"]');
      this.maxVisibleItems = 10;
      this.hasRendered = false;

      this.subscribe(
        WYATT.PubSub.events.searchResultsFetched,
        this.handleSearchResults.bind(this),
      );

      this.subscribe(
        WYATT.PubSub.events.clearAllFilters,
        this.handleClearAll.bind(this),
      );
    }

    handleSearchResults(event) {
      if (!event?.detail?.facets) {
        return;
      }

      if (this.hasRendered) {
        return;
      }

      Array.from(this.children).forEach((child) => {
        if (
          !(child instanceof HTMLTemplateElement) &&
          !(child instanceof HTMLScriptElement)
        ) {
          child.remove();
        }
      });

      this.render(event.detail);
      this.hasRendered = true;
    }

    handleClearAll() {
      this.hasRendered = false;
    }

    updateFilterCount(detailsElement, headingElement) {
      const checkedCount = detailsElement.querySelectorAll(
        'input[type="checkbox"]:checked',
      ).length;

      const existingContainer = headingElement.querySelector(
        ".accordion__heading-numbers-container",
      );
      if (existingContainer) {
        existingContainer.remove();
      }

      if (checkedCount > 0) {
        const numbersElement = this.numbersTemplate.content.cloneNode(true);
        numbersElement.querySelector(
          '[data-template-element="numbers"]',
        ).textContent = `${checkedCount}`;
        headingElement.appendChild(numbersElement);
      }
    }

    render({ facets }) {
      if (!facets) {
        return;
      }

      facets.forEach((facetGroup) => {
        const group = this.renderGroup(facetGroup);

        this.appendChild(group);
      });
    }

    renderGroup(facetGroup) {
      const group = this.groupTemplate.content.cloneNode(true);
      const values = group.querySelector('[data-template-element="values"]');
      const panel = group.querySelector(".accordion__panel");
      const headingElement = group.querySelector(
        '[data-template-element="heading"]',
      );
      const detailsElement = group.querySelector(".accordion__details");

      group.querySelector('[data-template-element="label"]').textContent =
        facetGroup.label;
      headingElement.textContent = facetGroup.label;

      facetGroup.values.forEach((facetValue, index) => {
        const facet = this.renderFacet(facetGroup, facetValue);
        const facetElement = facet.querySelector(".filters__item");
        const checkbox = facet.querySelector('input[type="checkbox"]');

        if (index >= this.maxVisibleItems) {
          facetElement.classList.add("hidden");
        }

        values.appendChild(facet);

        if (checkbox) {
          checkbox.addEventListener("change", () => {
            this.updateFilterCount(detailsElement, headingElement);
          });
        }
      });

      if (facetGroup.values.length > this.maxVisibleItems) {
        const readMoreButton = this.createReadMoreButton(values);
        panel.appendChild(readMoreButton);
      }

      setTimeout(() => {
        this.updateFilterCount(detailsElement, headingElement);
      }, 0);

      return group;
    }

    renderFacet(facetGroup, facetValue) {
      const { field } = facetGroup;
      const { type, value, label, active } = facetValue;

      const template = this[`${type}FacetTemplate`];
      const facet = template.content.cloneNode(true);
      const inputElement = facet.querySelector(
        '[data-template-element="input"]',
      );
      const labelElement = facet.querySelector(
        '[data-template-element="label"]',
      );

      if (type === "value") {
        inputElement.name = `filter.${field}`;
        inputElement.value = value;
      }

      if (type === "range") {
        const rangeFacet = facet.querySelector("range-facet");

        rangeFacet.dataset.facetField = field;
        rangeFacet.dataset.facetLabel = label;
      }

      inputElement.id = `filter-${this.config.id}-${facetGroup.field}-${facetValue.value}`;
      inputElement.dataset.facet = JSON.stringify(facetValue);
      inputElement.checked = active;
      labelElement.textContent = label;

      this.connectToForm(inputElement);

      return facet;
    }

    createReadMoreButton(valuesList) {
      const buttonWrapper = this.readMoreButtonTemplate.content.cloneNode(true);
      const button = buttonWrapper.querySelector(
        '[data-template-element="button"]',
      );
      const showMoreText = buttonWrapper.querySelector(
        '[data-template-element="show-more-text"]',
      );
      const showLessText = buttonWrapper.querySelector(
        '[data-template-element="show-less-text"]',
      );

      const allItems = Array.from(
        valuesList.querySelectorAll(".filters__item"),
      );
      const toggleableItems = allItems.slice(this.maxVisibleItems);

      let isExpanded = false;

      button.addEventListener("click", () => {
        isExpanded = !isExpanded;

        toggleableItems.forEach((item) => {
          item.classList.toggle("hidden", !isExpanded);
        });

        button.setAttribute("aria-expanded", isExpanded);

        showMoreText.classList.toggle("hidden", isExpanded);
        showLessText.classList.toggle("hidden", !isExpanded);
      });

      return buttonWrapper;
    }

    connectToForm(inputElement) {
      inputElement.setAttribute("form", this.config.formId);

      if (this.closest("form")) {
        return;
      }

      inputElement.addEventListener(
        "change",
        this.triggerFormChange.bind(this),
      );
    }

    triggerFormChange(event) {
      event.preventDefault();

      const { form } = event.target;
      const changeEvent = new Event("change", { bubbles: true });
      form.dispatchEvent(changeEvent);
    }
  },
);
